export default {
    language: "Español",
    StripeSuccess: {
        loading: "Procesando tu pago...",
        successMessage: "¡Tu suscripción ha sido activada con éxito!",
        processingError: "Error al procesar el pago, contáctanos",
    },
    Terms: {
        "tabs": {
            "terms": "Términos de servicio",
            "privacy": "Política de privacidad",
            "cookies": "Política de cookies"
        },
        "lastUpdated": "Última actualización: 20 de mayo de 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Introducción",
                    "description": "Bienvenido a ClixMagicAI. El uso de nuestros servicios implica que aceptas estos términos de servicio. Por favor, léelos detenidamente."
                },
                {
                    "title": "2. Descripción del servicio",
                    "description": "ClixMagicAI proporciona herramientas impulsadas por IA para eliminar marcas de agua de imágenes, vídeos y archivos PDF. Nuestros servicios están destinados a los siguientes usos legítimos:",
                    "items": [
                        "Eliminar marcas de agua de tu propio contenido",
                        "Eliminar marcas de agua de contenido para el que tienes los derechos apropiados para modificar",
                        "Con fines educativos y de investigación"
                    ]
                },
                {
                    "title": "3. Responsabilidades del usuario",
                    "description": "Al utilizar ClixMagicAI, aceptas:",
                    "items": [
                        "Subir únicamente contenido que poseas o para el que tengas los derechos apropiados para modificar",
                        "No utilizar nuestros servicios para ningún propósito ilegal o que infrinja cualquier ley",
                        "No intentar eludir nuestras medidas de seguridad o restricciones de uso",
                        "No utilizar nuestros servicios para infringir los derechos de propiedad intelectual de otros"
                    ]
                },
                {
                    "title": "4. Condiciones de la cuenta",
                    "description": "Es posible que necesites crear una cuenta para utilizar algunas funciones de nuestros servicios. Para iniciar sesión, puedes optar por utilizar una cuenta de Google o GitHub. Eres responsable de:",
                    "items": [
                        "Mantener la seguridad de tu cuenta",
                        "Todas las actividades que ocurran bajo tu cuenta",
                        "Proporcionar información precisa de la cuenta (incluyendo, pero no limitado a avatar, correo electrónico, nombre de usuario y ID de usuario)"
                    ]
                },
                {
                    "title": "5. Servicios gratuitos y de pago",
                    "description": "ClixMagicAI ofrece una cuota básica gratuita y opciones flexibles de compra de puntos para acceder a nuestras funciones de eliminación de marcas de agua:",
                    "items": [
                        "Cuota básica: Cada usuario recibirá automáticamente 3 puntos gratuitos diariamente, que se pueden utilizar para procesar contenido",
                        "Reglas de consumo de puntos: La eliminación de marcas de agua de imágenes consume 1 punto por operación, la eliminación de marcas de agua de vídeos consume 3 puntos por operación",
                        "Compra de puntos: Puedes optar por comprar paquetes de puntos para más uso, todos los puntos comprados son válidos permanentemente, sin restricciones de caducidad",
                        "Política de reembolso: Debido a la naturaleza instantánea y virtual de los servicios digitales, los puntos no pueden ser reembolsados una vez comprados con éxito"
                    ]
                },
                {
                    "title": "6. Derechos de propiedad intelectual",
                    "description": "El servicio ClixMagicAI, incluido todo el software, diseños y contenido que hemos creado, es nuestra propiedad intelectual. No puedes copiar, modificar o crear trabajos derivados basados en nuestros servicios sin permiso."
                },
                {
                    "title": "7. Limitación de responsabilidad",
                    "description": "ClixMagicAI proporciona el servicio \"tal cual\", sin garantías de ningún tipo. No somos responsables de ningún daño resultante de tu uso de nuestros servicios."
                },
                {
                    "title": "8. Cambios en los términos",
                    "description": "Podemos modificar estos términos en cualquier momento. El uso continuado de ClixMagicAI después de los cambios en los términos significa que aceptas los términos modificados."
                },
                {
                    "title": "9. Terminación",
                    "description": "Nos reservamos el derecho de terminar o suspender tu acceso a nuestros servicios inmediatamente, sin previo aviso, si creemos que tu comportamiento viola estos términos o daña a otros usuarios, a nosotros o a terceros."
                },
                {
                    "title": "10. Ley aplicable",
                    "description": "Estos términos se regirán por las leyes aplicables en el lugar de registro de nuestra empresa, sin tener en cuenta las disposiciones sobre conflictos de leyes."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Introducción",
                    "description": "En ClixMagicAI, valoramos tu privacidad y estamos comprometidos a proteger tus datos personales. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos tu información cuando utilizas nuestro sitio web y servicios. Al acceder a nuestro sitio web o utilizar cualquiera de nuestros servicios, aceptas las prácticas de procesamiento de datos descritas en esta política. Nos adherimos a las regulaciones de protección de datos aplicables."
                },
                {
                    "title": "2. Información que recopilamos",
                    "description": "Podemos recopilar los siguientes tipos de información:",
                    "items": [
                        { "bold": "Información de la cuenta", "text": "Avatar del usuario, dirección de correo electrónico, nombre de usuario e ID de usuario proporcionados al iniciar sesión a través de Google o GitHub" },
                        { "bold": "Datos de uso", "text": "Información sobre cómo utilizas nuestros servicios, incluidas las características a las que se accede y el tiempo de uso" },
                        { "bold": "Contenido subido", "text": "Imágenes, vídeos o archivos PDF que subes para su procesamiento" },
                        { "bold": "Información de pago", "text": "Información de pago al comprar suscripciones (procesada de forma segura a través de pasarelas de pago de terceros como Creem/Stripe/PayPal, solo mantenemos registros de estado de pago)" },
                        { "bold": "Datos técnicos", "text": "Dirección IP, tipo de navegador, información del dispositivo" }
                    ]
                },
                {
                    "title": "3. Cómo utilizamos tu información",
                    "description": "Utilizamos tu información para:",
                    "items": [
                        { "text": "Proporcionar, mantener y mejorar nuestros servicios" },
                        { "text": "Procesar y completar transacciones" },
                        { "text": "Enviar notificaciones técnicas y mensajes de soporte" },
                        { "text": "Responder a tus comentarios y preguntas" },
                        { "text": "Analizar patrones de uso para mejorar la experiencia del usuario, y procesar datos personales solo en la medida necesaria para cumplir con los propósitos del servicio" },
                        { "text": "Asegurar que el período de almacenamiento de datos personales no exceda el tiempo necesario" },
                        { "text": "Prevenir fraudes o actividades ilegales" }
                    ]
                },
                {
                    "title": "4. Seguridad de datos",
                    "description": "Implementamos medidas de seguridad conformes con los estándares de la industria para proteger tu información personal:",
                    "items": [
                        { "text": "Cifrado AES-256 para archivos durante la transmisión y almacenamiento" },
                        { "text": "Procesamiento de datos sensibles utilizando arquitectura de conocimiento cero" },
                        { "text": "Auditorías diarias de registros de seguridad y escaneos de vulnerabilidades" },
                        { "text": "El acceso de los empleados sigue el principio de privilegio mínimo" }
                    ]
                },
                {
                    "title": "5. Compartición de datos",
                    "description": "No vendemos tu información personal. Podemos compartir información con:",
                    "items": [
                        { "bold": "Proveedores de servicios", "text": "Limitado al procesamiento de datos necesario para proporcionar servicios específicos (como almacenamiento en la nube de CloundFlare, pasarelas de pago de terceros como Creem/Stripe/PayPal), que deben firmar acuerdos de procesamiento de datos" },
                        { "bold": "Requisitos legales", "text": "Cuando recibimos una citación válida, orden judicial u otro proceso legal que nos sea aplicable" }
                    ]
                },
                {
                    "title": "6. Tus derechos",
                    "description": "Según las leyes aplicables en tu región, puedes tener los siguientes derechos:",
                    "items": [
                        { "text": "Acceder a una copia de tus datos personales" },
                        { "text": "Rectificar información inexacta o incompleta" },
                        { "text": "Derecho a la eliminación de datos ('derecho al olvido'), a menos que tengamos una razón legal para retenerlos" },
                        { "text": "Oponerte a o restringir ciertos tipos de procesamiento de datos" },
                        { "text": "Derecho a la portabilidad de datos, puedes solicitar la transferencia de tus datos" }
                    ]
                },
                {
                    "title": "7. Privacidad de los niños",
                    "description": "Nuestros servicios no están dirigidos a menores de 16 años. De acuerdo con el Artículo 8 del Reglamento General de Protección de Datos (RGPD), el consentimiento para niños menores de 16 años debe ser proporcionado por el padre o tutor. Si tienes conocimiento de que un menor de 16 años nos ha proporcionado información personal, por favor contáctanos inmediatamente en support@clixmagic.com."
                },
                {
                    "title": "8. Cambios en esta política",
                    "description": "Podemos actualizar esta Política de Privacidad periódicamente. Te notificaremos de cualquier cambio significativo publicando la nueva política en esta página y actualizando la fecha de \"última actualización\". Para cambios importantes, notificaremos a los usuarios por correo electrónico u otra forma prominente."
                },
                {
                    "title": "9. Contáctanos",
                    "description": "Si tienes alguna pregunta sobre esta Política de Privacidad, por favor contáctanos en support@clixmagic.com. Si crees que tus datos han sido procesados inapropiadamente o tienes alguna inquietud, no dudes en contactarnos en cualquier momento."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Qué son las cookies",
                    "description": "Las cookies son pequeños archivos de texto que se colocan en tu ordenador o dispositivo móvil cuando visitas un sitio web. Permiten a los sitios web reconocer tu dispositivo y recordar si has visitado el sitio anteriormente."
                },
                {
                    "title": "2. Cómo utilizamos las cookies",
                    "description": "ClixMagicAI utiliza cookies para varios propósitos:",
                    "items": [
                        { "bold": "Cookies necesarias", "text": "Requeridas para la funcionalidad básica de nuestro sitio web (como gestión de sesiones y características de seguridad)" },
                        { "bold": "Cookies de preferencias", "text": "Recuerdan tus configuraciones y preferencias para mejorar tu experiencia, por ejemplo, recordando tu avatar, nombre de usuario, etc. después de iniciar sesión a través de Google o GitHub" },
                        { "bold": "Cookies analíticas", "text": "Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web recopilando información anónima" },
                        { "bold": "Cookies de marketing", "text": "Rastrean tus hábitos de navegación para ofrecer publicidad relevante a tus intereses" }
                    ]
                },
                {
                    "title": "3. Tipos de cookies que utilizamos",
                    "subsection": [
                        {
                            "title": "3.1 Cookies necesarias",
                            "description": "Estas cookies son esenciales para el funcionamiento adecuado del sitio web. Permiten funciones centrales como seguridad, gestión de red y acceso a la cuenta (incluido el inicio de sesión con Google y GitHub). Puedes configurar tu navegador para bloquear estas cookies, pero algunas partes del sitio web pueden no funcionar correctamente."
                        },
                        {
                            "title": "3.2 Cookies de rendimiento y analíticas",
                            "description": "Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web recopilando información anónima. Utilizamos estos datos para mejorar nuestro sitio web y servicios. Estas cookies no recopilan información que pueda identificar a un visitante."
                        },
                        {
                            "title": "3.3 Cookies de funcionalidad",
                            "description": "Estas cookies permiten a nuestro sitio web recordar las elecciones que haces (como preferencias de idioma o estado de inicio de sesión) para proporcionar funciones personalizadas mejoradas, como recordar tu estado de inicio de sesión a través de Google o GitHub."
                        },
                        {
                            "title": "3.4 Cookies de orientación y publicidad",
                            "description": "Estas cookies se utilizan para mostrar publicidad relevante a los visitantes y rastrear la efectividad de nuestras campañas publicitarias. Ten en cuenta que, dado que nuestro sitio web depende principalmente del inicio de sesión de terceros (Google y GitHub), este tipo de cookies se utilizan principalmente para mejorar la experiencia del usuario y no para marketing directo."
                        }
                    ]
                },
                {
                    "title": "4. Gestión de cookies",
                    "description": "Puedes controlar y gestionar las cookies de varias maneras. La mayoría de los navegadores web permiten gestionar las preferencias de cookies. Puedes:",
                    "items": [
                        { "text": "Eliminar cookies de tu dispositivo" },
                        { "text": "Bloquear cookies activando la configuración de tu navegador que te permite rechazar algunas o todas las cookies" },
                        { "text": "Configurar tu navegador para que te notifique cuando recibes cookies" }
                    ]
                },
                {
                    "title": "5. Cookies de terceros",
                    "description": "Algunas cookies son colocadas por terceros en nuestro sitio web. Estos terceros pueden incluir servicios analíticos (como Google Analytics) y redes publicitarias. Debido a cómo funcionan las cookies (las cookies solo pueden ser accedidas por la parte que las colocó originalmente), no controlamos el uso de estas cookies de terceros ni podemos acceder a ellas. Para los usuarios que inician sesión a través de Google y GitHub, nos aseguraremos de seguir las directrices de privacidad de estas plataformas al manejar la información relevante."
                },
                {
                    "title": "6. Actualización de esta política de cookies",
                    "description": "Podemos actualizar esta Política de Cookies de vez en cuando para reflejar cambios en tecnología, regulaciones o nuestras prácticas comerciales. Cualquier cambio será publicado en esta página y la fecha de revisión será actualizada."
                },
                {
                    "title": "7. Contáctanos",
                    "description": "Si tienes alguna pregunta sobre nuestro uso de cookies, por favor contáctanos en support@clixmagic.com."
                }
            ]
        }
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Correo electrónico",
            createdAt: "Fecha de creación",
            noRecord: "Sin registros",
            loginTime: "Hora de inicio de sesión",
        },
        orders: {
            title: "Historial de pedidos",
            loading: "Cargando...",
            refresh: "Actualizar",
            orderAmount: "Importe",
            points: "Puntos",
            createdAt: "Fecha de creación",
            orderType: "Tipo",
            status: "Estado",
            noOrders: "No hay pedidos",
            goToSubscription: "Comprar puntos",
            freeCredit: "Crédito gratuito",
            paidCredit: "Crédito pagado",
            queryOrderFailed: "Error al consultar el pedido",
            statusPaid: "Pagado",
            statusPending: "Pendiente",
            statusCancelled: "Cancelado",
            statusDeactivated: "Desactivado",
            checkoutUrlNotAvailable: "No se pudo obtener la URL de pago",
            verifyingPayment: "Verificando el estado del pago...",
            paymentSuccess: "Pago exitoso",
            paymentPending: "El pedido está pendiente de pago, por favor complete el pago",
            paymentFailed: "Pago fallido o cancelado",
            paymentStatus: "Estado del pago",
            paymentStatusDescription: "¿Ha completado el pago?",
            cancelPayment: "Cancelar pago",
            completedPayment: "Pago completado",
            warning: "Advertencia",
            confirmCancelOrder: "¿Está seguro de que desea cancelar este pedido? Esta acción no se puede deshacer.",
            cancel: "Cancelar",
            confirm: "Confirmar",
            cancellingOrder: "Cancelando pedido...",
            orderCancelledSuccess: "Pedido cancelado",
            cancelOrderFailed: "Error al cancelar el pedido",
            checkOrderStatusFailed: "Error al verificar el estado del pedido",
            promptClick: "Haga clic en el estado \"Pendiente\" para continuar con el pago",
        }
    },
    UserFeedback: {
        title: "Opiniones de usuarios",
        feedback: "Escucha evaluaciones reales de creadores y profesionales de todo el mundo sobre nuestra tecnología de procesamiento de imágenes con IA.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Sr. Lin",
                profession: "Editor de video y creador de contenido",
                rating: 5,
                comment: "¡Increíble! ClixMagicAI es súper rápido. Subes un video con marca de agua y en minutos obtienes una versión sin ella, sin pérdida de calidad. ¡Una herramienta indispensable para eliminar marcas de agua!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Sra. Su",
                profession: "Experta en redes sociales",
                rating: 5,
                comment: "ClixMagicAI salvó mi biblioteca de materiales de Instagram. Identifica con precisión marcas de agua complejas y el procesamiento de bordes es mucho más refinado que con otros programas, logrando un efecto visual más natural."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Sr. Chen",
                profession: "Productor de videos cortos",
                rating: 5,
                comment: "ClixMagicAI hace que eliminar marcas de agua sea súper conveniente. Proceso material de TikTok durante el trayecto y al llegar a la oficina descargo directamente la versión en alta definición. ¡La eficiencia se duplica! Una bendición para los creadores de contenido."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Sr. Huang",
                profession: "Diseñador gráfico y director creativo",
                rating: 5,
                comment: "Como diseñador estoy muy satisfecho. Al procesar imágenes con logos de clientes, la textura de fondo se restaura de forma natural, sin rastros de Photoshop, ahorrando mucho tiempo de postproducción."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Sra. Emily",
                profession: "Creadora freelance de contenido digital",
                rating: 5,
                comment: "¡He descubierto un tesoro! El precio de membresía es mucho más económico que otros productos similares del mercado, pero los resultados son mejores, especialmente al procesar marcas de agua transparentes con degradado."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Sr. Robertson",
                profession: "Productor de cursos de formación empresarial",
                rating: 5,
                comment: "ClixMagicAI es muy conveniente porque no requiere instalación. Las restricciones de permisos en los ordenadores de la empresa impiden instalar software, ahora puedo procesar material de cursos con el navegador, en cualquier momento y lugar."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Sra. Zhou",
                profession: "Ama de casa y editora de imágenes comunitarias",
                rating: 5,
                comment: "¡La interfaz es tan simple que hasta mi abuela podría usarla! Aquellos sin tiempo para aprender software profesional como Photoshop definitivamente deberían probar ClixMagicAI, es perfecto para principiantes técnicos como yo. ¡Jaja!"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Sr. Johnson",
                profession: "Planificador visual de comercio electrónico",
                rating: 5,
                comment: "ClixMagicAI es extremadamente potente, puede eliminar marcas de agua de imágenes, videos, objetos pequeños, transeúntes, texto y más. Sus funciones son completas, ¡lo recomiendo a todos!"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Sra. Fang",
                profession: "Aficionada a la fotografía y compartidora de contenido online",
                rating: 5,
                comment: "¡Wow! ¡Por fin encontré una herramienta para eliminar marcas de agua que no deteriora la calidad de imagen! ¡Es como magia! ¡Editar fotos ya no es un problema! ¡¡Lo recomiendo encarecidamente!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Sr. Williams",
                profession: "Profesor de educación online",
                rating: 5,
                comment: "La función de memoria de posición de marca de agua es súper útil. Al procesar series de videos de cursos, no necesito seleccionar repetidamente el área, ahorrando al menos media hora de trabajo y mejorando significativamente mi eficiencia de preparación docente."
            }
        ]
    },
    Order: {
        purchasePoints: "Comprar Puntos",
        subtitle: "Elija un paquete de puntos para disfrutar de nuestro servicio de eliminación de marcas de agua",
        loginReminderDesc: "Inicie sesión para comprar puntos",
        freeTag: "Gratis",
        freePlan: "Plan gratuito",
        autoActivated: "Activación automática",
        points: "Puntos",
        autoIncluded: "Regalo gratis",
        discount: "Descuento",
        purchase: "Comprar ahora",
        paymentStatusDescription: "¿Ha completado el pago?",
        paymentNotCompleted: "Pago no completado",
        queryOrderFailed: "Error al consultar estado",
        cancelPayment: "Cancelar pago",
        completedPayment: "Pago completado",
        warning: "Advertencia",
        confirmCancelOrder: "¿Seguro que desea cancelar este pedido? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Confirmar",
        selectProductFirst: "Seleccione un paquete primero",
        creatingOrder: "Creando pedido...",
        orderCreated: "Pedido creado",
        createOrderFailed: "Error al crear pedido",
        checkoutUrlNotAvailable: "Error al obtener link de pago",
        cancellingOrder: "Cancelando pedido...",
        orderCancelledSuccess: "Pedido cancelado",
        cancelOrderFailed: "Error al cancelar",
        verifyingPayment: "Verificando estado...",
        paymentSuccess: "Pago exitoso",
        paymentPending: "Pago pendiente, complete el pago",
        paymentFailed: "Pago fallido o cancelado",
        checkOrderStatusFailed: "Error al verificar estado",
        quickStart: "Inicio",
        shortTerm: "Corto plazo",
        recommended: "Recomendado",
        bestValue: "Mejor valor",
    },
    Login: {
        title: "Iniciar sesión",
        subtitle: "Inicio rápido con cuentas sociales",
        memberTip: "Inicie sesión para acceder a más funciones",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Iniciar sesión con GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Iniciar sesión con Google"
            }
        ],
        error: {
            serverError: "Error del servidor, inténtelo más tarde",
            networkError: "Error de red, verifique su conexión"
        }
    },
    OAuthCallback: {
        loading: "Procesando solicitud de inicio",
        pleaseWait: "Espere, verificando información...",
        error: "Error de inicio de sesión",
        backToHome: "Volver al inicio",
        success: "Inicio de sesión exitoso",
        redirecting: "Redirigiendo a la página principal..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Precios",
            faq: "Preguntas frecuentes",
        },
        login: "Iniciar sesión",
        userMenu: {
            account: "Cuenta",
            logout: "Cerrar sesión",
            credit: "Crédito",
            freeCredit: "Gratis",
            paidCredit: "Comprado",
            nextUpdate: "Próxima actualización",
            language: "Idioma",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Características de ClixMagicAI",
        advs: [
            {
                title: "Motor de reconocimiento IA: Detección automática de elementos intrusivos",
                desc: "Basado en algoritmos de aprendizaje profundo, identifica automáticamente marcas de agua, texto, rostros y elementos complejos en imágenes/videos, sin necesidad de marcado manual. Compatible con formatos de Instagram, TikTok y otras plataformas, con estricta protección de datos privados.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Eliminar marca"
            },
            {
                title: "Maestro en limpieza de imágenes: Elimina logos/fechas al instante, sin pérdida de calidad",
                desc: "Elimina con precisión marcas de agua de marcas, fechas de captura, stickers y otros elementos no deseados. La IA restaura automáticamente la textura del fondo, las imágenes procesadas lucen naturales como el original, perfectas para publicaciones en redes sociales.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Eliminar marca"
            },
            {
                title: "Eliminador de marcas dinámicas: Borra subtítulos/logos de plataformas",
                desc: "Elimina con un clic tarjetas finales de YouTube, marcas de TikTok y textos en movimiento. La IA rastrea y procesa cada fotograma, generando videos fluidos en 4K de alta calidad, compatible con formatos MP4/MOV y otros populares.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Eliminar marca"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Una herramienta profesional con IA para eliminar marcas de agua de imágenes, videos y PDF de forma rápida y natural.",
        fileTypes: {
            image: 'Eliminación en imágenes',
            pdf: 'Eliminación en PDF',
            video: 'Eliminación en videos'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Prueba diaria gratis", icon: "fa-gift" },
            { id: "imageTag", text: "Imágenes sin marcas", icon: "fa-image" },
            { id: "videoTag", text: "Videos sin marcas", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Con IA", icon: "fa-robot" },
            { id: "noRegTag", text: "Inicia y usa", icon: "fa-user-check" },
        ],
        videoPromt: "¡Próximamente!",
        videoDesc: "Estamos desarrollando la eliminación de marcas en videos para ofrecerle una experiencia más potente."
    },
    Footer: {
        social: {
            title: "Contáctenos",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Términos legales",
        terms: [
            {
                id: 1,
                title: "Privacidad",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Términos",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookies",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI. Todos los derechos reservados."
    },
    Task: {
        image: {
            imageSupportText: 'Soporta formatos jpg, jpeg, png, webp, heic, heif, máximo 10MB por archivo',
            imageFileTooLarge: 'Archivo demasiado grande (máx. 10MB)',
            invalidImageType: 'Formato no soportado, suba JPG, JPEG, PNG, WEBP, HEIC o HEIF',
            imageWillCost: 'Costará: 1 punto',
            hiecSupportText: 'Formatos HEIC/HEIF se convierten a PNG automáticamente',
            hiecSuccess: 'Conversión HEIC/HEIF exitosa',
            hiecFailed: 'Conversión HEIC/HEIF fallida',
            processingImageTip: 'Procesando su imagen, espere...',
            guide: {
                title: 'Guía',
                step1: 'Suba la imagen',
                step2: 'Marque el área o deje que la IA identifique la marca',
                step3: 'Clic en enviar'
            }
        },
        common: {
            remaining: 'Puntos restantes',
            nextUpdate: 'Próxima actualización',
            handleError: 'Error al procesar, intente con otro archivo',
            uploadFailed: 'Carga fallida',
            dragText: 'Arrastre archivos aquí o',
            clickText: 'clic para subir',
            loginRequired: 'Inicie sesión antes de subir archivos',
            noRemainingTasks: 'Ha usado todos sus puntos',
            loginNow: 'Iniciar sesión',
            upgradeNow: 'Comprar puntos',
            taskSubmitSuccess: 'Tarea enviada',
            taskSubmitError: 'Error al enviar',
            taskRetrySuccess: 'Reintento exitoso',
            taskRetryError: 'Reintento fallido',
            processing: 'Procesando',
            submit: 'Enviar',
            waiting: 'Esperando',
            completed: 'Completado',
            failed: 'Fallido',
            cancelled: 'Cancelado',
            url_not_found: 'Link no encontrado',
            deleted: 'Eliminado',
            refreshSuccess: 'Lista actualizada',
            refreshFailed: 'Error al actualizar',
            deleteSuccess: 'Tarea eliminada',
            deleteFailed: 'Error al eliminar',
            waitingForCompletion: 'Espere a que termine la tarea actual',
            loadOriginalImageFailed: 'Error al cargar imagen original',
            downloadFailed: 'Error al descargar',
            startingDownload: 'Iniciando descarga...',
            noTasks: 'Sin tareas',
            refresh: 'Actualizar',
            sort: 'Ordenar',
            noFilterTasks: 'Sin tareas {filter}',
            compare: 'Comparar',
            originalImage: 'Original',
            processedImage: 'Procesada',
            dragToCompare: '👈 Arrastre para comparar 👉',
            cancel: "Cancelar",
            delete: "Eliminar",
            retry: "Reintentar",
            download: "Descargar",
            createAt: "Creado",
            expiredAt: "Expira",
        },
        video: {
            videoSupportText: 'Soporta formatos mp4, mov, avi, mkv, máximo 100MB por archivo',
            videoFileTooLarge: 'Archivo demasiado grande (máx. 100MB)',
            invalidVideoType: 'Formato no soportado, suba MP4, MOV, AVI o MKV',
            videoWillCost: 'Costará: 3 puntos',
            processingVideoTip: 'Procesando su video, espere...',
            guide: {
                step1: 'Suba el video',
                step2: 'Seleccione tipo de marca y defina el área',
                step3: 'Clic en enviar'
            },
            annotationTools: 'Herramientas de marca',
            selectType: 'Seleccionar tipo',
            deleteAnnotation: 'Eliminar marca',
            clearAllAnnotations: 'Limpiar todo',
            annotationHelp: 'Ayuda',
            dragTip: 'Arrastre para dibujar área',
            resizeTip: 'Ajuste tamaño para coincidir',
            moveTip: 'Las marcas pueden moverse',
            processing: 'Procesando',
            submit: 'Enviar',
            taskSubmitSuccess: 'Tarea enviada',
            taskSubmitError: 'Error al enviar',
            retryTaskTip: 'Reintento exitoso',
            retryFailed: 'Reintento fallido',
            uploadFailed: 'Carga fallida',
            staticWatermarkDesc: 'Para marcas estáticas en posición fija',
            normalWatermarkDesc: 'Para marcas fijas normales',
            dynamicWatermarkDesc: 'Para marcas dinámicas cambiantes',
            moveWatermarkDesc: 'Para marcas que necesitan moverse'
        },
    },
    Router: {
        home: "Inicio",
        terms: "Términos de Servicio",
        privacy: "Política de Privacidad",
        cookie: "Política de Cookies",
        user: "Centro de Usuario",
    },
    FAQ: {
        title: "Guía de uso y preguntas frecuentes de ClixMagicAI",
        prompt: "¿Tiene algún problema o pregunta? Contáctenos en cualquier momento: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "¿Qué es ClixMagicAI y cómo funciona?",
                answer: "ClixMagicAI es una herramienta avanzada de eliminación de marcas de agua impulsada por IA. Permite identificar automáticamente marcas de agua en imágenes y videos, además de ofrecer la función de marcado manual. Para imágenes, admite múltiples formatos de conversión y garantiza una salida de alta calidad; para videos, puede procesar marcas de agua estáticas, dinámicas e incluso con cambios de forma."
            },
            {
                id : 2,
                question: "¿ClixMagicAI ofrece uso gratuito?",
                answer: "¡Sí, ofrecemos un servicio básico gratuito de 3 puntos diarios! Puede utilizarlos para procesar imágenes (1 punto por operación) o videos (3 puntos por operación). Además, puede comprar puntos adicionales que serán válidos permanentemente."
            },
            {
                id : 3,
                question: "¿Puedo comprar puntos adicionales?",
                answer: "¡Por supuesto! Además de los 3 puntos gratuitos diarios, puede obtener puntos adicionales a través de nuestras opciones de compra. Los puntos adquiridos son válidos permanentemente, sin fecha de caducidad."
            },
            {
                id : 4,
                question: "¿Qué formatos de archivo se admiten?",
                answer: "Para imágenes, admitimos formatos PNG, JPEG, JPG, WEBP, HEIC y HEIF, donde HEIC y HEIF se convertirán automáticamente a PNG. Para videos, admitimos varios formatos, incluyendo MP4 y MOV."
            },
            {
                id : 5,
                question: "¿Cómo se protege mi privacidad?",
                answer: "En ClixMagicAI, valoramos altamente la privacidad del usuario. Todos los archivos subidos se cifran y se eliminan automáticamente 24 horas después de completar el procesamiento. No guardamos ningún archivo de usuario ni información relacionada."
            },
            {
                id : 6,
                question: "¿Cómo puedo iniciar sesión en ClixMagicAI?",
                answer: "Admitimos inicio de sesión rápido a través de cuentas GitHub o Google, garantizando la seguridad de su cuenta mientras simplificamos el proceso de registro."
            },
            {
                id : 7,
                question: "¿Qué tan rápido es el procesamiento?",
                answer: "Gracias a nuestros servidores de alto rendimiento y algoritmos de IA optimizados, la mayoría de las tareas de eliminación de marcas de agua en imágenes se completan en 10 segundos, mientras que la eliminación en videos puede tardar tan solo 1 minuto. El tiempo real puede variar según el tamaño y la complejidad del archivo."
            },
            {
                id : 8,
                question: "¿Cómo es el resultado del procesamiento?",
                answer: "Nuestros modelos de IA están extensamente entrenados para eliminar inteligentemente marcas de agua de imágenes y videos, manteniendo la calidad del contenido original. Tanto las marcas de agua identificadas automáticamente como las marcadas manualmente se eliminan eficazmente, garantizando resultados naturales sin rastros."
            },
            {
                id : 9,
                question: "¿Cuánto tiempo permanecen disponibles las tareas?",
                answer: "Una vez completada la tarea, los archivos procesados permanecen disponibles en ClixMagicAI durante 24 horas para su descarga. Después de este período, los archivos se eliminan automáticamente de nuestros servidores para proteger su privacidad."
            },
            {
                id : 10,
                question: "¿Cuál es el límite de tamaño máximo de archivo?",
                answer: "Aceptamos imágenes de hasta 10MB y archivos de video de hasta 100MB. Los archivos que excedan estos límites pueden requerir compresión o recorte antes de cargarse."
            }
        ]
    }
}